import { sm2 } from 'sm-crypto'
import store from '@/store'

/**
 * 签名密钥
 */
export const publicQueryset = {
  publicKey: '0412182c164e1cdbea0626814d1cf13243ec18d90c2a96f09f2554434c6d50f40a6d6d6d26527d5439adcd0a032e8a059e9945d41faf95d7caa7cbec34592518e3',
  privateKey: '7469f280b22e22d41fd34588e3f02c03638f2abd34525fc0411fdfaeef9b173a',
  appId: 1297785942446092
}

/**
 * 参数签名，使用场景：登录密码
 * @param {*} queryset
 * @returns 签名后的值
 */
export function doSignature(queryset) {
  return sm2.doSignature(queryset, publicQueryset.privateKey, { der: true })
}

/**
 * 参数加密，使用场景：登录密码
 * @param {*} queryset
 * @returns 加密后的值
 */
export function doEncrypt(queryset) {
  const result = sm2.doEncrypt(queryset, publicQueryset.publicKey, 1)
  // sm2加密结果以04开头，表示未压缩的公钥格式，如果不以04开头，则在前面添加04
  return result.startsWith('04') ? result : '04' + result;
}

export function doDecrypt(data) {
  return sm2.doDecrypt(data, publicQueryset.privateKey, 1)
}

/**
 * 权限
 * @param {*} key
 */
export function hasPermission(key) {
  if (store.getters.roles.permissionList) {
    return store.getters.roles.level === 2 || store.getters.roles.permissionList.indexOf(key) !== -1 || false
  } else {
    return false
  }
}
/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * 将 URL 查询字符串解析为对象（兼容异常字符）
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url && url.split('?')[1]
  if (!search) {
    return {}
  }
  try {
    return Object.fromEntries(new URLSearchParams(search))
  } catch (e) {
    try {
      return JSON.parse(
        '{"' +
          decodeURIComponent(search)
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"')
            .replace(/\+/g, ' ') +
          '"}'
      )
    } catch (e2) {
      return {}
    }
  }
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

// 处理较大金额
export function bigNumberTransform(value, type) {
  const newValue = ['', '', '']
  let fr = 1000
  let num = 3
  let text1 = ''
  let text2 = ''
  let fm = 1
  if (value === '' || value == null || isNaN(value)) {
    return !type ? newValue : ''
  }
  if (value < 0) {
    value = Math.abs(value)
    text2 = '-'
  }
  while (value / fr >= 1) {
    fr *= 10
    num += 1
    // console.log('数字', value / fr, 'num:', num)
  }
  if (num <= 4) { // 千
    newValue[0] = value.toFixed(2)
    newValue[1] = ''
  } else if (num <= 8) { // 万
    // text1 = parseInt(num - 4) / 3 > 1 ? '千万' : '万'
    text1 = '万'
    // tslint:disable-next-line:no-shadowed-variable
    fm = text1 === '万' ? 10000 : 10000000
    if (value % fm === 0) {
      newValue[0] = parseInt(value / fm) + ''
    } else {
      newValue[0] = parseFloat(value / fm).toFixed(2) + ''
    }
    newValue[1] = text1
  } else { // 亿 if (num <= 16)
    // text1 = (num - 8) / 3 > 1 ? '千亿' : '亿'
    text1 = '亿'
    text1 = (num - 8) / 4 > 1 ? '万亿' : text1
    text1 = (num - 8) / 7 > 1 ? '千万亿' : text1
    text1 = (num - 8) / 10 > 1 ? '亿亿' : text1
    // tslint:disable-next-line:no-shadowed-variable
    fm = 1
    if (text1 === '亿') {
      fm = 100000000
    } else if (text1 === '千亿') {
      fm = 100000000000
    } else if (text1 === '万亿') {
      fm = 1000000000000
    } else if (text1 === '千万亿') {
      fm = 1000000000000000
    } else {
      fm = 1000000000000000000
    }
    if (value % fm === 0) {
      newValue[0] = parseInt(value / fm) + ''
    } else {
      newValue[0] = parseFloat(value / fm).toFixed(2) + ''
    }
    newValue[1] = text1
  }
  if (value < 1000) {
    newValue[0] = value.toFixed(2)
    newValue[1] = ''
  }
  newValue[0] = text2 ? text2 + newValue[0] : newValue[0]
  return !type ? newValue : (newValue[0] + newValue[1])
}

export function combineObject(obj, newObj) {
  return Object.assign({}, obj, newObj)
}

/**
 * 获取uuid
 */
/**
 * 生成 UUID v4
 * @returns {string}
 */
export function getUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
const testMqttOption = {
  ServerUrl: '',
  ServerPort: '',
  UserName: '',
  Password: '',
  TimeOut: 5000, // 超时
  KeepAlive: 0, // 心跳
  CleanSession: false, // 清除session，设置为true时，每次都以新session信息向服务器沟留~
  SSL: false, // 是否加密 （加密是wss前缀）
  FirstLevelTopic: 'bohu-ws-server'
}
const prodMqttOption = {
  ServerPort: '',
  UserName: '',
  Password: '',
  TimeOut: 5000, // 超时
  KeepAlive: 0, // 心跳
  CleanSession: false, // 清除session，设置为true时，每次都以新session信息向服务器沟留~
  SSL: false, // 是否加密 （加密是wss前缀）
  FirstLevelTopic: 'bohu-ws-server-prod'
}
export const host = process.env.VUE_APP_API_BASE_URL
export const baseUrl = '/bohu-bms-backend'
export const socketURL = process.env.VUE_APP_API_SOCKET_URL
export const mqttURL = process.env.VUE_APP_API_MQTT_URL
const isProdOrPre = ['production', 'pre'].includes(process.env.NODE_ENV)
export const mqttOption = isProdOrPre ? prodMqttOption : testMqttOption
